export default "__VITE_ASSET__Degvc2ji__"